import * as React from 'react';
import { Modal } from '@grandvisionhq/common';
import { useIntl } from '@grandvisionhq/state';
import { useCheckoutSettings } from '../../../../context/CheckoutSettings/context.js';
import '@swc/helpers';
import { PickupLocationInformation } from '../components/PickupLocationInformation.js';
import { PickupWarningMessage } from '../components/PickupWarningMessage.js';
import { PickupPointsFinderContainer } from './PickupPointsFinderContainer.js';

const PickupPointsContainer = ({ hideTitle =false , warningMessageOnly =false , onPickupPointSelect , selectedPickupPoint , onShippingModalClose  })=>{
    const { getLabel  } = useIntl();
    const { itemsToBeShipped  } = useCheckoutSettings();
    const [modalIsOpen, setModalIsOpen] = React.useState(false);
    const onPickupModalClose = ()=>{
        setModalIsOpen(false);
        onShippingModalClose === null || onShippingModalClose === void 0 ? void 0 : onShippingModalClose();
    };
    const onPickupModalShow = (event)=>{
        setModalIsOpen(true);
        event && event.preventDefault();
    };
    React.useEffect(()=>{
        if (!selectedPickupPoint) {
            setModalIsOpen(true);
        }
    }, [
        selectedPickupPoint
    ]);
    const labels = React.useMemo(()=>({
            error: getLabel('checkout.pickupPoints.error'),
            noSelection: getLabel('checkout.pickupPoints.selectPoint.message'),
            noSelectionLink: getLabel('checkout.pickupPoints.selectPoint.link'),
            title: getLabel('checkout.pickupPoints.title')
        })
    , [
        getLabel
    ]);
    const handlePickUpPointSelection = React.useCallback((pickupPoint)=>{
        if (!pickupPoint) {
            return;
        }
        setModalIsOpen(false);
        onPickupPointSelect(pickupPoint);
    }, [
        onPickupPointSelect
    ]);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, modalIsOpen && /*#__PURE__*/ React.createElement(Modal, {
        className: "checkout-step--shipping__modal",
        showIcon: true,
        iconClassName: "checkout-step--shipping__modal__close",
        isOpen: modalIsOpen,
        onModalClose: onPickupModalClose
    }, /*#__PURE__*/ React.createElement(PickupPointsFinderContainer, {
        onPickupPointSelect: handlePickUpPointSelection,
        errorMessage: labels.error,
        itemsToBeShipped: itemsToBeShipped
    })), selectedPickupPoint && !warningMessageOnly ? /*#__PURE__*/ React.createElement(PickupLocationInformation, {
        hideTitle: hideTitle,
        title: labels.title,
        location: selectedPickupPoint,
        onPickupModalShow: onPickupModalShow
    }) : /*#__PURE__*/ React.createElement(PickupWarningMessage, {
        labels: labels,
        onPickupModalShow: onPickupModalShow
    }));
};

export { PickupPointsContainer };
//# sourceMappingURL=PickupPointsContainer.js.map
